import React from 'react';

import { ClassMap, makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    padding: '1rem 1rem',
    backgroundColor: theme.palette.background.default,
    flexGrow: 1,
    flexShrink: 1,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem 1rem',
    },
  },
  inner: {
    ...common.flexColumn,
    maxWidth: '85rem',
    height: '100%',
    margin: '0 auto',
    rowGap: '1rem',
  },
}));

export interface ContainerProps {
  classes?: ClassMap<'container' | 'inner'>;
  children?: React.ReactNode;
}

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>((props, ref) => {
  const classes = useStyles();

  const { classes: customClasses = {}, children } = props;

  return (
    <div ref={ref} className={clsx(classes.container, customClasses.container)}>
      <div className={clsx(classes.inner, customClasses.inner)}>{children}</div>
    </div>
  );
});
